<div class="p-col-12 app-msg p-g-nopad" *ngIf="messages.length > 0">
  <div *ngFor="let message of messages">
    <p-messages
      [value]="message"
      (valueChange)="myCloseEvent(message)"
    ></p-messages>
  </div>
</div>
